export const FIVE9_CALL_API = Object.freeze({
  callsPath: 'calls',
  sessionIdField: 'five9SessionId',
  interactionIdField: 'five9InteractionId',
  callIdField: 'five9CallId',
  agentIdField: 'five9AgentId',
  callStateField: 'callState',
  dispositionField: 'disposition',
  directionField: 'direction',
  aniField: 'ani',
  dnisField: 'dnis',
  queueField: 'queue',
  campaignField: 'campaign',
  callStartedAtField: 'callStartedAt',
  callAnsweredAtField: 'callAnsweredAt',
  callEndedAtField: 'callEndedAt',
  talkTimeSecondsField: 'talkTimeSeconds',
  outcomeField: 'outcome',
  recordingUrlField: 'recordingUrl',
  transcriptField: 'transcript',
  summaryField: 'summary',
  transcriptReceivedAtField: 'transcriptReceivedAt'
});

export const FIVE9_CALL_QUEUE_VERSION = 1;
export const FIVE9_CALL_QUEUE_PREFIX = 'dispatchQore.five9.calls';

export const five9CallPath = (five9SessionId) => (
  `${FIVE9_CALL_API.callsPath}/${encodeURIComponent(five9SessionId)}`
);

export const five9Click2DialRegisterPath = () => (
  `${FIVE9_CALL_API.callsPath}/click2dial-register`
);

export const five9TranscriptPath = (five9SessionId) => (
  `${five9CallPath(five9SessionId)}/transcript`
);

export const five9DispatchLinkPath = (five9SessionId) => (
  `${five9CallPath(five9SessionId)}/dispatches`
);
